<template>
  <div>
    <PCNavbar selectIndex="9"/>
    <MobileNavBar :currentActive="8" />
    <carbonTreasure/>
    <router-view></router-view>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import carbonTreasure from '@/views/carbonTreasure/index.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    carbonTreasure
  },
}
</script>

<style>
.el-timeline-item__timestamp{
  font-size: 0.9rem !important;
  padding: 1rem 0;
}
</style>